import { isAfter, isBefore, isValid, parse } from "date-fns";
import { FieldValidationParams } from "../types";
import { validationException } from "./validator.utils";

const CONTROL_NAME = "datepicker";
export const validateDateField = async ({
  args,
  names,
  onValidated,
  onInvalid,
  onValidationStarted,
}: FieldValidationParams<string>) => {
  return new Promise((resolve, reject) => {
    const [inputFormat, value, defs, schema] = args;
    const { instancePath = "" } = schema;
    const paths = instancePath.split("/");
    const name = paths[paths.length - 1];
    const { maxDate, minDate } = defs;

    const checkValidated = () => {
      if (onValidated) {
        onValidated(names, name, CONTROL_NAME, []);
      }
    };
    const checkInvalid = (errorCode = 0) => {
      if (onInvalid) {
        onInvalid(names, name, CONTROL_NAME, errorCode, []);
      }
    };

    if (onValidationStarted) {
      onValidationStarted("datepicker", name);
    }
    try {
      const now = new Date();
      const parsedDate = parse(value, inputFormat, now);
      const isValueValid = isValid(parsedDate);
      if (!isValueValid) {
        checkInvalid(0);
        return reject(validationException("date", "Invalid date format"));
      }
      const year = parsedDate.getFullYear();
      if (year.toString().length !== 4) {
        checkInvalid(0);
        return reject(validationException("date", "Invalid date format"));
      }

      if (minDate) {
        const minDateValue = parse(minDate as string, inputFormat, now);
        const gtOrEqMin = isAfter(minDateValue, parsedDate);
        // if greater than or equal to the min date throw an error
        if (gtOrEqMin) {
          checkInvalid(0);
          return reject(
            validationException("minDate", "Date is less that the min date"),
          );
        }
      }

      if (maxDate) {
        const maxDateValue = parse(maxDate as string, inputFormat, now);
        const ltOrEqMax = isBefore(maxDateValue, parsedDate);
        // if less than or equal to the max date throw an error
        if (ltOrEqMax) {
          checkInvalid(0);
          return reject(
            validationException("maxDate", "Date is greater than the max date"),
          );
        }
      }
      checkValidated();
      return resolve(true);
    } catch (e) {
      checkInvalid(500);
      reject(validationException("date", "Invalid date format."));
    }
  });
};
